/* Semedi v5: smooth accordions, desktop tabs for product details, FAQ tabs, review carousel + read more,
   add-on card toggle. Small, dependency free, runs once and again on theme editor section reloads. */
(function () {
  'use strict';
  if (window.__pn5) return;
  window.__pn5 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Smooth <details> open/close for .pn5-acc and .pn5-faq-q
  function animDetails(d) {
    if (d.__pn5a) return; d.__pn5a = true;
    var sum = d.querySelector('summary'), body = d.querySelector('.pn5-acc-b, .pn5-faq-a');
    if (!sum || !body) return;
    sum.addEventListener('click', function (e) {
      var det = d.closest('[data-pn-det]');
      if (det && det.classList.contains('is-tabs')) { e.preventDefault(); return; }
      if (reduce) return;
      e.preventDefault();
      if (d.open) {
        body.style.height = body.scrollHeight + 'px'; body.style.overflow = 'hidden';
        requestAnimationFrame(function () { body.style.transition = 'height .32s cubic-bezier(.2,.7,.2,1)'; body.style.height = '0px'; });
        setTimeout(function () { d.open = false; body.style.cssText = ''; }, 330);
      } else {
        var grp = d.getAttribute('data-pn-group');
        if (grp) document.querySelectorAll('details[data-pn-group="' + grp + '"][open]').forEach(function (o) { if (o !== d) o.open = false; });
        d.open = true; var h = body.scrollHeight;
        body.style.height = '0px'; body.style.overflow = 'hidden';
        requestAnimationFrame(function () { body.style.transition = 'height .36s cubic-bezier(.2,.7,.2,1)'; body.style.height = h + 'px'; });
        setTimeout(function () { body.style.cssText = ''; }, 380);
      }
    });
  }

  // Product details: tabs on wide screens
  function detTabs(det) {
    if (det.__pn5t) return; det.__pn5t = true;
    var bar = det.querySelector('[data-pn-tabs]');
    var items = [].slice.call(det.querySelectorAll('.pn5-acc'));
    if (!bar || items.length < 2) return;
    var mq = window.matchMedia('(min-width: 990px)');
    items.forEach(function (d, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pn5-tab'; b.setAttribute('role', 'tab');
      b.id = 'pn5-tab-' + i + '-' + Math.random().toString(36).slice(2, 6);
      var ic = d.querySelector('.pn5-acc-ic'); if (ic) b.innerHTML = ic.innerHTML;
      b.appendChild(document.createTextNode(d.querySelector('.pn5-acc-h').textContent));
      b.addEventListener('click', function () { sel(i, true); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length; sel(n, true); bar.children[n].focus(); }
      });
      bar.appendChild(b);
    });
    var cur = 0;
    function sel(i) {
      cur = i;
      items.forEach(function (d, j) { d.classList.toggle('is-cur', j === i); if (mq.matches) d.open = j === i; });
      [].forEach.call(bar.children, function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; });
    }
    function mode() {
      var on = mq.matches;
      det.classList.toggle('is-tabs', on); bar.hidden = !on;
      if (on) sel(cur); else items.forEach(function (d) { d.open = false; });
    }
    if (mq.addEventListener) mq.addEventListener('change', mode); else mq.addListener(mode);
    mode();
  }

  // FAQ category tabs
  function faqTabs(root) {
    if (root.__pn5f) return; root.__pn5f = true;
    var tabs = root.querySelectorAll('[data-pn-faq-tab]');
    if (!tabs.length) return;
    function show(g) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-pn-faq-tab') === g ? 'true' : 'false'); });
      root.querySelectorAll('[data-pn-faq-panel]').forEach(function (p) { p.hidden = g !== '*' && p.getAttribute('data-pn-faq-panel') !== g; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-pn-faq-tab')); }); });
  }

  // Carousels with arrows: [data-pn-car] contains [data-pn-car-track] and [data-pn-car-btn="-1|1"]
  function carousel(c) {
    if (c.__pn5c) return; c.__pn5c = true;
    var tr = c.querySelector('[data-pn-car-track]'); if (!tr) return;
    var btns = c.querySelectorAll('[data-pn-car-btn]');
    function step() { var f = tr.children[0]; return f ? f.getBoundingClientRect().width + parseFloat(getComputedStyle(tr).columnGap || 16) : tr.clientWidth; }
    function upd() {
      btns.forEach(function (b) {
        var d = parseInt(b.getAttribute('data-pn-car-btn'), 10);
        b.disabled = d < 0 ? tr.scrollLeft < 4 : tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
      });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { tr.scrollBy({ left: parseInt(b.getAttribute('data-pn-car-btn'), 10) * step(), behavior: reduce ? 'auto' : 'smooth' }); }); });
    tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  // Read more for long review texts
  function readMore(el) {
    if (el.__pn5r) return; el.__pn5r = true;
    var txt = el.querySelector('[data-pn-more-text]'), btn = el.querySelector('[data-pn-more-btn]');
    if (!txt || !btn) return;
    if (txt.scrollHeight <= txt.clientHeight + 2) { btn.hidden = true; return; }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Add-on cards: clicking anywhere on the card toggles the checkbox
  function addons() {
    document.querySelectorAll('[data-pn-addon]').forEach(function (row) {
      if (row.__pn5ad) return; row.__pn5ad = true;
      row.addEventListener('click', function (e) {
        if (e.target.closest('select, label, input, a, button')) return;
        var cb = row.querySelector('.pn-addon-cb'); if (cb) cb.click();
      });
    });
  }

  function init() {
    document.querySelectorAll('details.pn5-acc, details.pn5-faq-q').forEach(animDetails);
    document.querySelectorAll('[data-pn-det]').forEach(detTabs);
    document.querySelectorAll('[data-pn-faq]').forEach(faqTabs);
    document.querySelectorAll('[data-pn-car]').forEach(carousel);
    document.querySelectorAll('[data-pn-more]').forEach(readMore);
    addons();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
